import * as React from "react";
import { forwardRef } from "react";
const SvgTriangleRight = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32", ref, ...props }, /* @__PURE__ */ React.createElement("path", { d: "M11 23.875a1.142 1.142 0 0 0 1.947.791l8-7.875c.214-.211.339-.492.339-.791 0-.3-.125-.58-.339-.791l-8-7.875A1.142 1.142 0 0 0 11 8.125v15.75Z" }));
const ForwardRef = forwardRef(SvgTriangleRight);
export default ForwardRef;
